import { useSelector } from 'react-redux'
import { selectDocsFormData } from '../../redux-state/selectors'
import { FUEL_TYPE_MAP } from '../docs/constants'
// DMV: Vehicle Type was echoed raw out of redux here, so a VIN-decoded
// pickup read "Truck" on Docs while Fees read "Pickup Truck" for the same
// LT quote. Resolve it through the shared label table instead — see
// utility/vehicleTypeLabel.js.
import { vehicleTypeLabel } from '../utility/vehicleTypeLabel'
import { wholeNumber } from '../utility/wholeNumber';

function VehicleInformation() {
  const docsFormData = useSelector(selectDocsFormData)

  return (
    <>
      <div className='border-t-2 border-t-gray-100 mb-3'>
        <div className='text-gray-700 mt-6 font-bold'>
          Vehicle Information <span className='text-xs text-gray-600 font-normal ml-1'>{docsFormData?.vinCode}</span>
        </div>
      </div>

      <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-8 mb-6'>
        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {docsFormData?.vehicleType &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Vehicle Type:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {vehicleTypeLabel(docsFormData?.vehicleType)}
              </div>
            </div>
          }

          {docsFormData?.modelYear &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Model Year:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.modelYear}
              </div>
            </div>
          }

          {docsFormData?.model &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Model:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.model}
              </div>
            </div>
          }

          {docsFormData?.numberOfAxles &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Number of Axles:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.numberOfAxles}
              </div>
            </div>
          }

          {docsFormData?.fuelType &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Fuel Type:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {FUEL_TYPE_MAP[docsFormData?.fuelType]}
              </div>
            </div>
          }

          {wholeNumber(docsFormData?.odometer) &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
               Odometer:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {wholeNumber(docsFormData?.odometer)}
              </div>
            </div>
          }

          {docsFormData?.color &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Color:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.color}
              </div>
            </div>
          }

          {wholeNumber(docsFormData?.gvw) &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                GVW:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {wholeNumber(docsFormData?.gvw)} lbs
              </div>
            </div>
          }

          {/* Gross vehicle weight RATING -- a different figure from the GVW
              above. Resolved by /api/decode-vin from VINAudit's gross_weight,
              gross_vehicle_weight_rating, or the "Standard GVWR" equipment row.
              Shown here as well as on the summary report so the download keeps
              matching the screen; ATC's Docs service has no GVWR field, so this
              is display only and redux-state/docs/api.js sends no GVWR key. */}
          {wholeNumber(docsFormData?.gvwr) &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                GVWR:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {wholeNumber(docsFormData?.gvwr)} lbs
              </div>
            </div>
          }
          
          {wholeNumber(docsFormData?.horsepower) &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Horsepower:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {wholeNumber(docsFormData?.horsepower)}
              </div>
            </div>
          }
        </div>

        <div className='flex flex-col w-full min-w-0 text-gray-700 gap-2'>
          {docsFormData?.condition &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Condition:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.condition}
              </div>
            </div>
          }

          {docsFormData?.make &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Make:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.make}
              </div>
            </div>
          }

          {docsFormData?.bodyStyle &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Body Style:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.bodyStyle}
              </div>
            </div>
          }

          {docsFormData?.numberOfTires &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Number of Tires:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.numberOfTires}
              </div>
            </div>
          }

          {docsFormData?.cylinders &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Cylinders:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.cylinders}
              </div>
            </div>
          }

          {docsFormData?.rimSize &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Rim Size (inches):
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.rimSize}
              </div>
            </div>
          }
          
          {wholeNumber(docsFormData?.vehicleWeight) &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                Vehicle Weight:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
              {wholeNumber(docsFormData?.vehicleWeight)} lbs
              </div>
            </div>
          }

          {docsFormData?.mpg &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                MPG (Average):
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {docsFormData?.mpg}
              </div>
            </div>
          }

          {docsFormData?.msrp &&
            <div className='flex flex-row justify-between gap-2 items-start'>
              <div>
                MSRP:
              </div>
              <div className='font-medium text-right break-words min-w-0'>
                {Number(docsFormData?.msrp || 0).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                })}
              </div>
            </div>
          }
        </div>
      </div>
    </>
  )
}

export default VehicleInformation